module.exports = __webpack_public_path__ + "media/images/turbochargers/Garrett_old-c8d6fe00ae5624da554f7c4c4b604216.jpg";